import * as clipboard from 'clipboard-polyfill';
import Content from 'js/components-v2/pages/UserDashboard/Content';
import Sidebar from 'js/components-v2/pages/UserDashboard/Sidebar';
import AppContent from 'js/components/AppContent';
import { AppButton } from 'js/new/Components/App';
import { useTruncate } from 'js/new/Hooks/useTruncate';
import { formatCurrency } from "js/services/Format";
import { makeRequest } from "js/services/Network";
import AppState from 'js/stores/AppState';
import AppUser from "js/stores/AppUser";
import UserDashboardPageState from 'js/stores/pages/UserDashboardPageState';
import React, { useState } from 'react';

const Offers = () => {
  const page = UserDashboardPageState.create();
  const [offers, setOffers] = useState([])
  const [refLink, setRefLink] = useState('loading...');
  const [loading, setLoading] = useState(true);
  const [clicked, setClicked] = useState(false);

  function copyReferralLink() {
    clipboard.writeText(refLink);
    setClicked(true);

    setTimeout(() => setClicked(false), 5000);
  }

  React.useEffect(async () => {
    AppState.setCurrentPage('UserDashboardPage');
    await page.load();

    const userAlias = AppUser.login;
    const urlPart = window.location.href.replace("dashboard/offers", "b")
    setRefLink(`${urlPart}/${userAlias}`)

    makeRequest('offers-dashboard-data', '', '')
      .then(response => setOffers(response.data?.offers))
      .catch(error => { });

    setLoading(false);
  }, []);

  const headers = [
    'Item',
    'Offer ID',
    'Quantity',
    'Price (N)',
    'Seller',
    'Status',
  ]

  function shareTo(target) {
    const title = "Sharing some POD " + <img src="/images/icons/love-51.png" alt="love" />
    if (navigator.share) {
      navigator.share({
        title,
        url: refLink,
        text: `Enjoy 500 naira bonus on your first transaction!`,
      });
    } else if (target === 'facebook') {
      Facebook.ui({
        method: 'share',
        href: refLink,
      });
    }
  }

  return (
    <AppContent className='user-dashboard d-lg-flex align-items-stretch'>
      <Sidebar currentPage='UserOffersPage' pageState={page} />

      <Content currentPage='UserOffersPage' showCards={false}>
        <div className='bg-white tw-p-4 md:tw-px-8 mt-3 tw-rounded-xl'>
          <h3 className="tw-mb-0">My Offers</h3>
        </div>

        <div className="tw-mt-3 new-pod-ui bg-white tw-p-4 md:tw-p-8 tw-rounded-xl tw-space-y-3 tw-relative">
          <div className='tw-flex tw-justify-between tw-items-center tw-z-50'>
            <div>
              <h5>Send this link to a seller to start a transaction</h5>
              <p>Send this link to a seller to start a transaction. Get N3,000 more after your first transaction.</p>
            </div>

            <div className='border tw-border-gray-100 tw-bg-white tw-rounded-full tw-p-2 tw-hidden md:tw-flex tw-gap-4 tw-items-center tw-z-50'>
              <img
                src="/images/v2/buyers/trustees.png"
                alt="Trustees"
                className="tw-h-12 tw-w-auto"
              />
              <p className='tw-flex-1'>Trusted by thousands of buyers</p>
            </div>
          </div>

          <div className='tw-flex tw-justify-between tw-items-center tw-flex-wrap tw-gap-2 tw-z-50'>
            <div className='tw-flex tw-flex-1 tw-justify-between tw-items-center tw-p-2 tw-rounded-2xl' style={{ border: "1px dashed #6D60F6", overflowWrap: "break-word" }}>
              <p className='tw-flex-1 tw-mr-4'>{useTruncate(refLink)}</p>
              <AppButton onClick={() => copyReferralLink()} className='tw-text-xs md:tw-text-sm'>{clicked === true ? 'Link Copied' : 'Copy link'}</AppButton>
            </div>

            <div className="tw-flex tw-flex-1 tw-justify-between md:tw-justify-end tw-gap-4 md:tw-gap-8 tw-z-50" style={{ border: "none" }}>
              {[
                { platform: 'twitter', icon: 'TwitterX' },
                { platform: 'facebook', icon: 'Facebook' },
                { platform: 'whatsapp', icon: 'WhatsApp' },
                { platform: 'instagram', icon: 'Insta' },
                { platform: 'tiktok', icon: 'TikTok' }
              ].map(({ platform, icon }) => (
                <div key={platform} style={{ cursor: 'pointer' }} onClick={e => shareTo(platform)}>
                  <img
                    src={`/images/icons/${icon}.png`}
                    alt={platform.charAt(0).toUpperCase() + platform.slice(1)}
                    className="tw-h-auto referral-share-icon"
                  />
                </div>
              ))}
            </div>
          </div>

          <img
            loading="lazy"
            src="/assets/brand/pod-bg-logo-side-up.png"
            alt="PayOnDelivery"
            className="tw-absolute tw-top-0 tw-right-2 tw-z-0 tw-h-auto md:tw-w-60"
          />
        </div>

        <div className="tw-mt-3 new-pod-ui bg-white tw-p-4 md:tw-p-8">
          <div className="tw-overflow-x-auto">
            <table className="tw-table tw-table-auto tw-w-full">
              <thead>
                <tr>
                  {headers.map((head, i) => (
                    <th
                      key={i}
                      className={`tw-p-4 tw-whitespace-nowrap tw-bg-gray-50 tw-font-normal ${i === 0
                        ? 'tw-rounded-l-xl'
                        : i === headers.length - 1
                          ? 'tw-rounded-r-xl'
                          : ''
                        }`}
                    >
                      {head}
                    </th>
                  ))}
                </tr>
              </thead>

              <tbody>
                {offers.map(offer => {
                  const { id, title, price, quantity } = offer;

                  return (
                    <tr key={id}>
                      <td>{title}</td>
                      <td>#{id}</td>
                      <td>{quantity}</td>
                      <td>{formatCurrency(price)}</td>
                      {/* Time */}
                      {/* Seller */}
                      {/* <td>{link}</td> */}
                    </tr>
                  )
                })}
              </tbody>
            </table>
          </div>

          {offers.length < 1 &&
            <div className='tw-text-center tw-space-y-4 tw-mt-4'>
              <img
                src="/images/icons/empty-referral.svg"
                alt="offers"
                className='tw-h-40 tw-w-auto'
              />

              <p>{loading ? 'Loading offers...' : 'No offers Yet'}</p>
            </div>
          }
        </div>
      </Content>
    </AppContent>
  );
}

export default Offers;
